"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_COMPONENT_CONFIGURATION = {
  charting: {}
};